<template>
  <div>
    <TermsCom class="m-doc"></TermsCom>
  </div>
</template>
<script>
import TermsCom from '../components/termsCom.vue'
export default {
  components: {
    TermsCom,
  },
}
</script>
<style lang="scss">
@import '@/styles/public';
.m-doc {
  padding: 0 60px;
  padding-bottom: 80px;
  .title {
    text-align: center;
    font-size: 72px;
    font-weight: bold;
    color: $theme-color;
    margin: 0px 0 60px;
  }
  .text {
    font-size: 40px;
    color: #565d75;
  }
  .s-title {
    color: $theme-color;
    font-size: 56px;
    margin: 70px 0 30px;
  }
}
</style>
